/* Yakishimi — le strict nécessaire.
   1) mise à jour du panier sans bouton
   2) galerie de la fiche produit : une grande image + vignettes
   3) agrandissement au clic
   Tout est une amélioration : sans ce script, la page reste complète et
   utilisable — les images sont simplement empilées et les formulaires
   Shopify fonctionnent seuls. */
(function () {
  'use strict';

  /* ── Panier : soumettre à la modification d'une quantité ── */
  document.querySelectorAll('.panier__ligne input[name="updates[]"]').forEach(function (champ) {
    champ.addEventListener('change', function () {
      var formulaire = champ.closest('form');
      if (formulaire) formulaire.submit();
    });
  });

  /* ── Galerie ──────────────────────────────────────────── */
  var galerie = document.querySelector('[data-galerie]');
  var vues = galerie ? Array.prototype.slice.call(galerie.querySelectorAll('[data-galerie-vue]')) : [];
  var barre = galerie ? galerie.querySelector('[data-galerie-vignettes]') : null;

  if (galerie && vues.length > 1 && barre) {
    // On ne masque les vues qu'ici : si le script échoue avant, tout reste visible.
    galerie.classList.add('js-galerie');
    barre.hidden = false;

    var vignettes = Array.prototype.slice.call(barre.querySelectorAll('[data-galerie-cible]'));

    var montrer = function (index) {
      vues.forEach(function (vue) {
        vue.classList.toggle('est-active', vue.dataset.galerieVue === String(index));
      });
      vignettes.forEach(function (v) {
        var actif = v.dataset.galerieCible === String(index);
        v.classList.toggle('est-active', actif);
        if (actif) { v.setAttribute('aria-current', 'true'); }
        else { v.removeAttribute('aria-current'); }
      });
    };

    vignettes.forEach(function (v) {
      v.addEventListener('click', function () { montrer(v.dataset.galerieCible); });
    });

    // Flèches gauche/droite quand le focus est dans la barre de vignettes.
    barre.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var courant = vignettes.findIndex(function (v) { return v.classList.contains('est-active'); });
      if (courant < 0) return;
      var suivant = e.key === 'ArrowRight'
        ? (courant + 1) % vignettes.length
        : (courant - 1 + vignettes.length) % vignettes.length;
      e.preventDefault();
      montrer(vignettes[suivant].dataset.galerieCible);
      vignettes[suivant].focus();
    });
  }

  /* ── Agrandissement ───────────────────────────────────── */
  var declencheurs = document.querySelectorAll('[data-agrandir]');
  if (!declencheurs.length) return;

  var loupe = null;
  var image = null;
  var dernierFocus = null;

  var construire = function () {
    loupe = document.createElement('div');
    loupe.className = 'loupe';
    loupe.setAttribute('role', 'dialog');
    loupe.setAttribute('aria-modal', 'true');
    loupe.setAttribute('aria-label', 'Image agrandie');
    loupe.hidden = true;

    image = document.createElement('img');
    image.className = 'loupe__image';

    var fermer = document.createElement('button');
    fermer.type = 'button';
    fermer.className = 'loupe__fermer';
    fermer.textContent = 'Fermer';
    fermer.addEventListener('click', masquer);

    loupe.appendChild(image);
    loupe.appendChild(fermer);
    loupe.addEventListener('click', function (e) { if (e.target === loupe) masquer(); });
    document.body.appendChild(loupe);
    return fermer;
  };

  var boutonFermer = null;

  function masquer() {
    if (!loupe || loupe.hidden) return;
    loupe.hidden = true;
    document.body.classList.remove('loupe-ouverte');
    if (dernierFocus) dernierFocus.focus();
  }

  function afficher(src, legende, origine) {
    if (!loupe) boutonFermer = construire();
    dernierFocus = origine;
    image.src = src;
    image.alt = legende || '';
    loupe.hidden = false;
    document.body.classList.add('loupe-ouverte');
    boutonFermer.focus();
  }

  declencheurs.forEach(function (b) {
    b.addEventListener('click', function () {
      afficher(b.dataset.agrandir, b.dataset.legende, b);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (!loupe || loupe.hidden) return;
    if (e.key === 'Escape') { masquer(); return; }
    // Le dialogue ne contient qu'un bouton : on y maintient le focus.
    if (e.key === 'Tab') { e.preventDefault(); boutonFermer.focus(); }
  });
})();
